<template>
    <table style="border-style: hidden;">
        <tbody>
            <tr>
                <td>
                    <img v-if="Logo" :src="Logo" class="country-flag mr-2" />
                </td>
                <td :style="'min-width: ' + width" style="text-wrap: balance;">
                    {{ Name }}
                </td>
            </tr>
        </tbody>
    </table>
</template>
<script>
export default {
    name: 'mediaCard',
    props: ['Logo', 'Name', 'width'],
    data() {
        return {
        };
    },
    methods: {
    },
};
</script>